import { NavLink } from 'react-router-dom';

const items = [
  { to: '/', icon: '⌂', label: 'Dashboard' },
  { to: '/projets', icon: '▦', label: 'Projets' },
  { to: '/ressources', icon: '☰', label: 'Ressources' },
  { to: '/perso', icon: '✎', label: 'Espace perso' },
];

export default function IconSidebar({
  onSearch,
  onToggleFocus,
  focusOn,
}: {
  onSearch: () => void;
  onToggleFocus: () => void;
  focusOn: boolean;
}) {
  return (
    <aside className="icon-sidebar">
      <div className="brand">BIM</div>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.to === '/'}
          title={it.label}
          className={({ isActive }) => `icon-btn ${isActive ? 'active' : ''}`}
        >
          {it.icon}
        </NavLink>
      ))}
      <button
        type="button"
        className="icon-btn"
        onClick={onSearch}
        title="Recherche globale (Cmd/Ctrl + K)"
      >
        ⌕
      </button>
      <button
        type="button"
        className={`icon-btn ${focusOn ? 'active' : ''}`}
        onClick={onToggleFocus}
        title={focusOn ? 'Quitter le mode focus' : 'Mode focus (masque sidebars)'}
      >
        {focusOn ? '◉' : '◎'}
      </button>
      <div style={{ flex: 1 }} />
      <a
        className="icon-btn"
        href="https://bimitel.vercel.app"
        target="_blank"
        rel="noreferrer"
        title="BIMitel (nouvel onglet)"
      >
        ↗
      </a>
    </aside>
  );
}
